import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, vShow as _vShow, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "livechat-frame" }
const _hoisted_2 = { class: "frame-header" }
const _hoisted_3 = { class: "frame-main" }
const _hoisted_4 = ["src"]

import { onMounted, ref } from 'vue';
import { usePopupStore } from '@/store'


export default {
  __name: 'LiveChatFrame',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const popupStore = usePopupStore();

const iframeRef = ref(null);
const loading = ref(true);

onMounted(() => {
  iframeLoad();
})

const iframeLoad = () => {
  loading.value = true;
  // 兼容处理
  if (iframeRef.value.attachEvent) {
    // IE
    iframeRef.value.attachEvent("onload", () => {
      loading.value = false;
    });
  } else {
    // 非IE
    iframeRef.value.addEventListener('load', () => {
      loading.value = false;
    })
  }
}

return (_ctx, _cache) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_Loading = _resolveComponent("Loading")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: true,
      position: "bottom",
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "close-btn flex justify-center",
            onClick: _cache[0] || (_cache[0] = $event => (emit('onClose')))
          }, [
            _createVNode(_component_van_icon, {
              name: "close",
              class: "close-icon"
            })
          ])), [
            [_directive_audio, void 0, "close"]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (loading.value)
            ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("iframe", {
            ref_key: "iframeRef",
            ref: iframeRef,
            src: _unref(popupStore).livechatFrameUrl,
            width: "100%",
            height: "100%",
            style: {"border":"none"}
          }, null, 8, _hoisted_4), [
            [_vShow, !loading.value]
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

}